import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useKratosSession } from "@saflib/ory-kratos-sdk";
import { getOrganizationQuery } from "@vendata/power-up-sdk";

export function useSellPartLoader() {
  const sessionQuery = useKratosSession();
  const loggedIn = computed(
    () =>
      sessionQuery.status.value === "success" &&
      sessionQuery.data.value !== null,
  );

  const organizationQuery = useQuery({
    ...getOrganizationQuery(),
    enabled: loggedIn,
  });

  return {
    sessionQuery,
    organizationQuery,
  };
}
